import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";
import { IconButton } from "../ui";

interface PaginacaoListagemProps {
  totalCount: number;
  rowsPerPage: number;
  sx?: any;
  page: number;
  handleChangePage: (event: unknown, newPage: number) => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowsPerPageOptions?: number[];
}

export function PaginacaoListagem({
  totalCount,
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPageOptions = [5, 10],
}: PaginacaoListagemProps) {
  const from = totalCount === 0 ? 0 : page * rowsPerPage + 1;
  const to = Math.min((page + 1) * rowsPerPage, totalCount);
  const lastPage = Math.max(0, Math.ceil(totalCount / rowsPerPage) - 1);

  return (
    <div className="flex flex-wrap items-center justify-end gap-4 py-2 text-sm text-slate-600 dark:text-slate-300">
      <div className="flex items-center gap-2">
        <span>Linhas por página</span>
        <select
          value={rowsPerPage}
          onChange={(e) =>
            handleChangeRowsPerPage(
              e as unknown as React.ChangeEvent<HTMLInputElement>
            )
          }
          className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm outline-none focus:border-primary-500 dark:border-slate-600 dark:bg-slate-800"
        >
          {rowsPerPageOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      <span>
        {from}–{to} de {totalCount}
      </span>

      <div className="flex items-center gap-1">
        <IconButton
          size={32}
          disabled={page === 0}
          onClick={(e) => handleChangePage(e, 0)}
        >
          <ChevronsLeft className="h-4 w-4" />
        </IconButton>
        <IconButton
          size={32}
          disabled={page === 0}
          onClick={(e) => handleChangePage(e, page - 1)}
        >
          <ChevronLeft className="h-4 w-4" />
        </IconButton>
        <IconButton
          size={32}
          disabled={page >= lastPage}
          onClick={(e) => handleChangePage(e, page + 1)}
        >
          <ChevronRight className="h-4 w-4" />
        </IconButton>
        <IconButton
          size={32}
          disabled={page >= lastPage}
          onClick={(e) => handleChangePage(e, lastPage)}
        >
          <ChevronsRight className="h-4 w-4" />
        </IconButton>
      </div>
    </div>
  );
}

